module.exports = __webpack_public_path__ + "img/LS.574730be.png";